import pathTrace from './pathTrace';

/**
 * Pure derivation: given a starting cell index, return the path + verse.
 */
export default function deriveReading(startIndex, data) {
  const pathCells = pathTrace(startIndex, data.paths);
  const verse = data.verses[startIndex];
  if (!verse || typeof verse.devanagari !== 'string') {
    throw new Error(`verses[${startIndex}] is missing or malformed`);
  }
  return { pathCells, verse };
}
